import { useRecoilState, useRecoilValue } from 'recoil';

import { DividedPage } from '../../../components/DividedPage';
import { RadioButton } from '../../../components/RadioButton';
import { pickupLocationState, showParkingLotInDrawerState } from '../../atoms';
import { ParkingLotPickupOption } from './ParkingLotPickupOption';

interface IPickupMethod {
	driveThru: boolean;
	parkingLot: boolean;
	inStore: boolean;
}
export const PickupMethod = ({
	driveThru,
	parkingLot,
	inStore
}: IPickupMethod): JSX.Element => {
	const [pickupLocation, setPickupLocation] =
		useRecoilState(pickupLocationState);

	const showParkingLotInDrawer = useRecoilValue(showParkingLotInDrawerState);

	return (
		<DividedPage
			dividerProps={{ borderColor: 'border-gray', my: 0 }}
			className="checkout-pickup-method"
		>
			{inStore && (
				<RadioButton
					className="py-3"
					id="inStore"
					value="IN_STORE"
					label="Pick up at store"
					clickHandler={() => setPickupLocation('IN_STORE')}
					active={pickupLocation === 'IN_STORE'}
				/>
			)}

			{driveThru && (
				<RadioButton
					className="py-3"
					id="driveThru"
					value="DRIVE_THRU"
					label="At drive-thru"
					clickHandler={() => setPickupLocation('DRIVE_THRU')}
					active={pickupLocation === 'DRIVE_THRU'}
				/>
			)}

			{parkingLot && (
				<ParkingLotPickupOption
					showInDrawer={showParkingLotInDrawer}
					parkingLotActive={pickupLocation === 'PARKING_LOT'}
					clickHandler={setPickupLocation}
				/>
			)}
		</DividedPage>
	);
};
